import {
  CHOOSE_CATEGORY,
} from '../actions/type';

const initialState = {
  category: 'all',
};

export default function( state = initialState, action ) {
  switch (action.type) {
    case CHOOSE_CATEGORY:
      return {
        ...state,
        category: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/categoryAnalysis_reducer.js